import { axiosCore } from './http-core-service';

/**
 * Méthode qui ajout une preference de notification
 * @return si valide
 */
export const addNotificationPreference = async (userId: number, mandateId: number): Promise<number> => {
    // Création d'un json pour la requête
    let data = {
        userId: userId,
        mandateId: mandateId,
    };
    const response = await axiosCore.post('/api/notification_preferences', data);
    return response.data?.id;
};

/**
 * Méthode qui permet de supprimer la préférence de notification
 * @param id identifiant de la notificaiton
 */
export const deleteNotificationPreference = async (id: number) => {
    const response = await axiosCore.delete(`/api/notification_preferences/${id}`);
    return response.data;
};
